import * as Yup from 'yup';

import { BraceOrderStatus } from '@constants/brace-order-status';
import { PatientState } from '@constants/patient-state';
import { IInsuranceInfo, insuranceInfoValidationSchema } from '@models/insurance-info';

type PatientStatus = PatientState | BraceOrderStatus;

export interface IPatient {
  id?: string;
  clinicId: number;
  firstName: string;
  lastName: string;
  dateOfBirth: Date;
  email: string;
  phoneNumber: string;
  hasNoHealthInsurance: boolean;
  insuranceInfo?: IInsuranceInfo;
}

export interface IPatientInfo {
  patientId: string;
  height: number;
  weight: number;
}

export interface IPatientSummary {
  id: string;
  name: string;
  status: PatientStatus;
  action: string[];
}

export const patientStatuses: PatientStatus[] = [
  ...Object.values(PatientState),
  ...Object.values(BraceOrderStatus),
];

export const patientValidationSchema = Yup.object<any, Partial<Record<keyof IPatient, Yup.AnySchema>>>({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  dateOfBirth: Yup.date().required(),
  email: Yup.string()
    .email()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .notRequired(),
  phoneNumber: Yup.string()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .matches(/^\d\d\d \d\d\d-\d\d\d\d$/, { excludeEmptyString: true })
    .notRequired(),
  hasNoHealthInsurance: Yup.boolean().required(),
  insuranceInfo: Yup.object().when('hasNoHealthInsurance', {
    is: (hasNoHealthInsurance: boolean) => !hasNoHealthInsurance,
    then: (s) => s.shape(insuranceInfoValidationSchema.fields).required(),
    otherwise: (s) => s,
  }),
});
